import React from 'react'

import { Auth } from 'aws-amplify'
import { Col, Badge, Button, Row, OverlayTrigger, Popover } from 'react-bootstrap'
import { Bell } from 'react-feather'
import { Link } from 'react-router-dom'

import { UserButton } from '../auth/auther'
import type { AuthState, CognitoUserAttributes, Permission } from '../../App.d'
import * as ApiDefinitions from '../../../../back-end/utilities/apiDefinitions'
import * as Request from '../../utilities/request'

import './userProfile.css'

interface UserProfileProps {
	authState: AuthState
	userAttributes: CognitoUserAttributes | null | undefined
	permission: Permission
	accounts: ApiDefinitions.Account[]
	selectedOrg?: ApiDefinitions.AccountXeroOrg
}

const refreshSession = async () => {
	const session = await Auth.currentSession()
	const user = await Auth.currentAuthenticatedUser()
	return new Promise((resolve, reject) => {
		// eslint-disable-next-line
		user.refreshSession(session.getRefreshToken(), (err: any, session: any) => {
			if (err) {
				reject(err)
			} else {
				resolve(session)
			}
		})
	})
}

const UserProfile = (props: UserProfileProps) => {
	// const [buttonLoading, updateButtonLoading] = React.useState<boolean>(false)
	const [accountOrgs, updateAccountOrgs] = React.useState<ApiDefinitions.AccountXeroOrg[] | null>(null) // eslint-disable-line
	const alerts = props.accounts.filter((acc) => acc.userAccountInvitationAccepted === null)

	const getAccountOrgs = async () => {
		if (props.userAttributes && props.userAttributes?.['custom:currentAccountId']) {
			const req = await Request.get(`organisation?where=AccountID==${props.userAttributes?.['custom:currentAccountId']}`)
			if (req.data.accountXeroOrgs.length > 0) {
				updateAccountOrgs(req.data.accountXeroOrgs)
			}
		}
	}

	React.useEffect(() => {
		getAccountOrgs()
	}, [props.userAttributes]) // eslint-disable-line

	const onAccountSwitch = async (eventKey: string) => {
		const accountID = eventKey
		const selectedAccount = props.accounts.find((account) => account.accountID === accountID)
		await Auth.currentAuthenticatedUser()

		if (selectedAccount) {
			const user = await Auth.currentAuthenticatedUser()

			await Auth.updateUserAttributes(user, {
				'custom:currentAccountId': accountID,
				'custom:userAccountId': selectedAccount.userAccountID,
				'custom:role': JSON.stringify({
					os: selectedAccount.osPermissionID,
					lc: selectedAccount.lcPermissionID,
					tayg: selectedAccount.taygPermissionID,
				}),
			})
			await refreshSession()

			// if(selectedUserAccount.UserAccountStatusID !== UserAccountStatus.Active) {
			// 	history.push(`invite?code=${selectedUserAccount.UserAccountID}`)
			// }

			window.location.href = '/'
			window.location.reload()
		}
	}

	if (props.userAttributes === null || props.userAttributes === undefined) {
		return <Link to="/login" />
	} else {
		return (
			<Row>
				<Col xs="auto" className="alert-bell">
					{alerts.length > 0 ? (
						<OverlayTrigger
							trigger="click"
							key="bottom"
							placement="bottom"
							overlay={
								<Popover id="popover-positioned-bottom">
									<Popover.Header as="h3">{`You have an account invite`}</Popover.Header>
									<Popover.Body>
										{alerts.map((alert) => (
											<div className="bell-alert-row" key={alert.accountID}>
												<p>
													{alert.owner?.email} <Button onClick={() => onAccountSwitch(alert.accountID!)}>View</Button>
												</p>
											</div>
										))}
									</Popover.Body>
								</Popover>
							}
						>
							<div>
								<Bell size={30} className={'blue'} />
								<Badge
									style={{
										position: 'absolute',
										top: 0,
										right: 0,
										padding: 5,
										borderRadius: 10,
										fontWeight: 'bold',
									}}
									bg="danger"
									pill
								>
									{alerts.length}
								</Badge>
							</div>
						</OverlayTrigger>
					) : (
						<Bell size={30} className={'blue'} />
					)}
				</Col>
				<Col xs="auto">
					<UserButton userAttributes={props.userAttributes} permission={props.permission} accounts={props.accounts} selectedOrg={props.selectedOrg} />
				</Col>
			</Row>
		)
	}
}

export default UserProfile
